import { Form } from '@tencent/tea-component';
import classnames from 'classnames';
import React, { FC, useCallback, useEffect, useState } from 'react';
import thumpImg from 'src/assets/imgs/upload-thumb.png';
import CropperUpload from 'src/components/CropperUpload';

import styles from './upload.module.scss';
interface IProps {
  defaultHeadUrl: string;
  isInForm?: boolean;
  className?: string;
  uploadMsg?: string;
  minWidth?: number;
  minHeight?: number;
  style?: any;
  onUploadComplete: (data: CosInfo) => void;
  getStatus?: (status: string) => any;
}

const UploadBox: FC<IProps> = (props: IProps) => {
  const {
    defaultHeadUrl,
    isInForm = false,
    className = '',
    uploadMsg,
    minHeight = 240,
    minWidth = 240,
    onUploadComplete,
    getStatus,
  } = props;
  const [avatarImg, setAvatarImg] = useState(thumpImg);
  const [status, updateStatus] = useState(undefined);
  const [fileName, updateFileName] = useState('');
  const onDeleteImage = useCallback(() => {
    onUploadComplete?.({ cosId: '', url: '' });
  }, [onUploadComplete]);
  const changeStatus = useCallback(
    (params) => {
      updateFileName(params?.name);
      getStatus?.(params?.status);
      if (params?.status === 'loading' || !params.status || params?.status === 'cancel')
        return updateStatus(undefined);
      updateStatus(params?.status);
    },
    [status, fileName],
  );
  useEffect(() => {
    setAvatarImg(defaultHeadUrl);
    updateFileName('');
  }, [defaultHeadUrl]);
  if (isInForm) {
    return (
      <Form>
        <Form.Item label="照片" status={status} className={className}>
          <CropperUpload
            confirm={onUploadComplete}
            onChangeFileStatus={changeStatus}
            aspectRatio={minWidth / minHeight}
            minWidth={minWidth}
            minHeight={minHeight}
            image={avatarImg}
            imageName={fileName}
            uploadBtnsIn={true}
            onDelete={onDeleteImage}
            isDeaultImage={avatarImg === defaultHeadUrl}
            accept={'image/png,image/jpeg,image/jpg'}
            uploadMsg={uploadMsg || '推荐使用240px*240px尺寸，支持png/jpg/jpeg格式，大小不超过5M'}
            imageClassName={classnames(fileName && 'has-bg', styles.guestAvatarFit)}
          />
        </Form.Item>
      </Form>
    );
  }
  return (
    <CropperUpload
      confirm={onUploadComplete}
      onChangeFileStatus={changeStatus}
      aspectRatio={minWidth / minHeight}
      minWidth={minWidth}
      minHeight={minHeight}
      image={avatarImg}
      imageName={fileName}
      uploadBtnsIn={true}
      onDelete={onDeleteImage}
      isDeaultImage={avatarImg === defaultHeadUrl}
      accept={'image/png,image/jpeg,image/jpg'}
      uploadMsg={uploadMsg || '推荐使用240px*240px尺寸，支持png/jpg/jpeg格式，大小不超过5M'}
      imageClassName={classnames(styles.guestAvatarFit)}
    />
  );
};
export interface CosInfo {
  url: string;
  cosId: string;
}

export default UploadBox;
